<template>
  <form>
  <modal :showModal="showModal" @close-modal="$emit('close-modal')" title="Update Status" width="30">
    <div class="particulars-img-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 col-lg-12 col-12">
            <label for="" class="label">Current Status </label>
            <input type="text" class="input" v-model="currentStatus" />
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <label for="" class="label">Updated By</label>
            <input type="text" class="input" v-model="updatedBy"/>
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <label for="" class="label">Date Last Updated</label>
            <el-date-picker type="date" v-model="lastUpdated" placeholder="Start Date" class="w-100 mr-3" />
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <label for="" class="label">New status</label>
            <el-select v-model="status" placeholder="Select status">
              <el-option v-for="(option, i) in statuses" :label="option" :value="option" :key="i" />
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <div class="button-wrapper">
      <button @click="$emit('close-modal')">Cancel</button>
      <base-button text="Update" :disabled="checkFields" :loading="loading" @click="updateStatus" />
    </div>


  </modal>
</form>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
    booking: Object,
    editingFleet: Object,
    currentStatus: String,
    lastUpdated: String,
    id : String,
    updating : Boolean,
    statusArray: {
      type: Array,
      default: () => [
        // "inTransit",
        // "processing",
        // "delayed",
        // "canceled",
        // "pending",
        // "fleet_scheduled_for_maintenance",
        // "dropped_of",
        // "declined",
        // "picked_up",
        // "assigned",
        // "unassigned",
        // "loading",
        // "on_deliver",
      ]
    },
  },
  data() {
    return {
      updatedBy: '',
      startDate: null,
      loading: false,
      status: null,
      loadedStatus: [],
      activityTypea: "",
      message: "I just updated this shipment",
    };
  },
  computed: {
    statuses() {
      if (this.statusArray.length > 0) {
        return this.statusArray;
      } else {
        return this.loadedStatus
      }
    },
    disableButton() {
      if (this.status.length) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    async getShippingsStatus() {
      try {
        this.loading = true;
        let response = await this.$_getShippingsStatus();
        this.loadedStatus = response.data.data;
        this.$emit("booking-subaction-completed");
        this.closeModal();
        this.loading = false;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
        // console.log(error);
      }
    },
    async updateStatus() {
      try {
        await this.$_updateShipping(this.booking.id, {
        currentStatus: this.currentStatus,
        updatedBy: this.updatedBy,
        lastUpdated: this.lastUpdated,
        status: this.status,
      })
      console.log(this.booking.id, 'na so')
        this.loading = true
        this.generateToast("Shiping Updated", "success")
        this.loading = false;
        this.$emit("close-modal");
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
  mounted() {
    // alert("name");
    this.getShippingsStatus();
  },
};
</script>

<style scoped>
.button-wrapper {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
.bg{
  background-color: #c5bd00 !important;
}
</style>
